import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadMetrologyDataFailed, loadMetrologyDataSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadMetrologyData(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/certificate`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadMetrologyDataSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadMetrologyDataFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadMetrologyDataFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
